import { Component, Input, ViewEncapsulation } from "@angular/core";
import { AuthenticationService } from "@common/services";
import { InsightsService } from "@core/services";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "environments/environment";


@Component({
    selector: "app-chat-quote-modal",
    templateUrl: "./chat-quote-modal.component.html",
    styleUrls: ['./chat-quote-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChatQuoteModalComponent{
  // Inputs
  @Input() title: string;
  @Input() content: string;
  @Input() prompts: string;

  constructor(
    public activeModal: NgbActiveModal,
    private _authenticationService: AuthenticationService,
    private _log: InsightsService
  ) {}

  /**
   * Función que sirve para cerrar el modal
   */
  closeModal(): void {
    this.activeModal.close();
  }


  selectPrompt(val: string){
    this._log.traceInfo(
                environment.projects.Bix,
                `Seleccionó el siguiente ejemplo de la galería de prompts: ${val}`,
                val,
                this._authenticationService.currentUserValue
            );
    this.activeModal.close(val);
  }

}
